/* ET - EA Reviews: turns the review cards into a Swiper slider below 750px and back into the grid above it.
   Swiper is loaded globally (layout/theme.liquid). Without it the cards stay a CSS scroll-snap row on mobile. */
(() => {
  if (customElements.get('et-ea-reviews-slider')) return;

  const MOBILE_QUERY = '(max-width: 749px)';

  class EtEaReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.mql = window.matchMedia(MOBILE_QUERY);
      this.onChange = () => this.sync();
      this.mql.addEventListener('change', this.onChange);
      this.sync();
    }

    disconnectedCallback() {
      if (this.mql) this.mql.removeEventListener('change', this.onChange);
      this.destroy();
    }

    sync() {
      if (this.mql.matches) {
        this.init();
      } else {
        this.destroy();
      }
    }

    init() {
      if (this.swiper || typeof window.Swiper !== 'function') return;

      const offset = Number(this.dataset.offset) || 0;
      this.swiper = new window.Swiper(this, {
        wrapperClass: 'et-ea-reviews__track',
        slideClass: 'et-ea-reviews__card',
        slidesPerView: 'auto',
        spaceBetween: 10,
        slidesOffsetBefore: offset,
        slidesOffsetAfter: offset,
        grabCursor: true,
        watchOverflow: true,
      });
    }

    destroy() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define('et-ea-reviews-slider', EtEaReviewsSlider);
})();
